import React, { FC } from "react";

export interface AlertComponentProps {
  style: any;
  options: any;
  message: any;
  close: any;
}

const AlertComponent: FC<AlertComponentProps> = ({
  style,
  options,
  message,
  close,
}) => {
  return (
    <div style={style}>
      {options.type === "info" && "!"}
      {options.type === "success" && ":)"}
      {options.type === "error" && ":("}
      {message}
      <button onClick={close}>X</button>
    </div>
  );
};

export default AlertComponent;
